// Module
var code = "<h2 id=\"bankruptcy\">Bankruptcy</h2> <p>Find out what your next steps are if you filed or are considering filing for bankruptcy. </p> ";
// Exports
export default code;